var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Messages")]),_vm._l((_vm.messages),function(message){return _c('ul',{key:message},[_c('li',[_vm._v(_vm._s(message))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }